import LooseItemInfoCard from './looseItemInfoCard.container';
export default LooseItemInfoCard